import { render } from "./PracticeSetupPage.vue?vue&type=template&id=48a6ea12"
import script from "./PracticeSetupPage.vue?vue&type=script&lang=js"
export * from "./PracticeSetupPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__